import news from "./news.json";

export default news;